import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainLayout from "../layouts/MainLayout.js";
import { useAppContext } from "../stores/AppContext/context.js";
import NotFound from "./NotFound/NotFound.js";
import Rewards from "./Rewards/index.js";
export const defaultRoutes = [
    {
        i18nKey: "home",
        path: "/",
        element: _jsx(Rewards, {}),
    },
];
export const ClientRoutes = memo(() => {
    const { state: { clientSettings }, } = useAppContext();
    const conformedRoutes = useMemo(() => {
        return [
            ...clientSettings.routes.map((config) => {
                return (_jsx(Route, { element: config.element, path: config.path === "/" ? undefined : config.path, index: config.path === "/" }, config.path));
            }),
            _jsx(Route, { element: _jsx(NotFound, {}), path: "*" }, "not-found"),
        ];
    }, [clientSettings.routes]);
    return (_jsx(BrowserRouter, { children: _jsx(Routes, { children: _jsx(Route, { path: "/", element: _jsx(MainLayout, {}), children: conformedRoutes }) }) }));
});
//# sourceMappingURL=routes.js.map